import { useState } from "react";
import { Button, Col, Form, Modal, Row, InputGroup } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { LenderContactType, MortgageLenderItem } from "./MortgageLenderTypes";
import { SelectLenderFieldList } from "./SelectLenderFieldList";

type SigningAuthority = {
    name: string,
    title?: string,
}

type Register = {
    name: string,
}

type LenderType = {
    Corporation?: string,
    LDDLenderID?: string,
    LenderID?: string,
    Lender?: string,
    PrivateLender?: string,
    SpouseNotOnTitle?: string,
    Branch?: string,
    TransitNum?: string,
    InstitutionNum?: string,
    Contact?: string,
    Phone?: string,
    Fax?: string,
    Email?: string,
    LenderProgramID?: string,
    SameAsMailing?: string,
    MailingStreetAddress?: string,
    MailingCity?: string,
    MailingProvince?: string,
    MailingPostalCode?: string,
    ServiceStreetAddress?: string,
    ServiceCity?: string,
    ServiceProvince?: string,
    ServicePostalCode?: string,
    registerNames?: Register[],
    signingAuthority?: SigningAuthority[],
    Comment?: string,
    differentRegistration?: string,
}

type IProps = {
    fileListColumns: string[];
    searchTable: string;
    setShowLender: (boolean) => void;
    LenderEntry: MortgageLenderItem;
    callBranch: () => void;
    subBranch: LenderContactType | undefined;
    typeOfLender: "Misc" | "Mortgage_lender";
}

export const NewMortgageLender = (props: IProps) => {
    const [registerAsNewLender, setRegisterAsNewLender] = useState<boolean>(false);
    const [serviceAddressAsMailAddress, setServiceAddressAsMailAddress] = useState<boolean>(false);
    const [registerNames, setRegisterNames] = useState<Register[]>([{ name: '' }]);
    const [signingAuthority, setSigningAuthority] = useState<SigningAuthority[]>([{ name: '', title: '' }]);
    const [selectLenderName, setSelectLenderName] = useState<string>('');
    const [selectLenderCode, setSelectLenderCode] = useState<boolean>(false);
    const [selectLenderCodeName, setSelectLenderCodeName] = useState<string>('');
    const [privateLenderBoolean, setPrivateLenderBoolean] = useState<boolean>(false);

    const handleSubmit = function (e) {
        e.preventDefault();
        let serviceStreetVal, serviceCityVal, serviceProvinceVal, servicePostalCodeVal;
        if ((document.getElementById('formServiceAddressCheckbox') as HTMLInputElement).checked) {
            serviceStreetVal = (document.getElementById('formStreet') as HTMLInputElement).value;
            serviceCityVal = (document.getElementById('formCity') as HTMLInputElement).value;
            serviceProvinceVal = (document.getElementById('formProvince') as HTMLInputElement).value;
            servicePostalCodeVal = (document.getElementById('formPostalCode') as HTMLInputElement).value;
        } else {
            serviceStreetVal = (document.getElementById('formServiceStreet') as HTMLInputElement).value;
            serviceCityVal = (document.getElementById('formServiceCity') as HTMLInputElement).value;
            serviceProvinceVal = (document.getElementById('formServiceProvince') as HTMLInputElement).value;
            servicePostalCodeVal = (document.getElementById('formServicePostalCode') as HTMLInputElement).value;
        }

        let newMortgageLender: LenderType = {
            Corporation: (document.getElementById('formCorporationCheckbox') as HTMLInputElement).checked ? '1' : '0',
            LDDLenderID: props.LenderEntry['LDDLenderID'].toString(),
            LenderID: props.LenderEntry['LenderID'].toString(),
            Lender: (document.getElementById('formLenderName') as HTMLInputElement).value,
            PrivateLender: (document.getElementById('formPrivateLender') as HTMLInputElement).checked ? '1' : '0',
            SpouseNotOnTitle: (document.getElementById('formNotOnTitle') as HTMLInputElement)?.value,
            Branch: (document.getElementById('formBranchName') as HTMLInputElement).value,
            TransitNum: (document.getElementById('formTransitBranch') as HTMLInputElement).value,
            InstitutionNum: (document.getElementById('formInstitutionBranch') as HTMLInputElement).value,
            Contact: (document.getElementById('formResponsiblePerson') as HTMLInputElement).value,
            Phone: (document.getElementById('formPhoneNumber') as HTMLInputElement).value,
            Fax: (document.getElementById('formFaxNumber') as HTMLInputElement).value,
            Email: (document.getElementById('formEmail') as HTMLInputElement).value,
            LenderProgramID: (document.getElementById('formLenderCode') as HTMLInputElement).value,
            SameAsMailing: (document.getElementById('formServiceAddressCheckbox') as HTMLInputElement).checked ? '1' : '0',
            MailingStreetAddress: (document.getElementById('formStreet') as HTMLInputElement).value,
            MailingCity: (document.getElementById('formCity') as HTMLInputElement).value,
            MailingProvince: (document.getElementById('formProvince') as HTMLInputElement).value,
            MailingPostalCode: (document.getElementById('formPostalCode') as HTMLInputElement).value,
            ServiceStreetAddress: serviceStreetVal,
            ServiceCity: serviceCityVal,
            ServiceProvince: serviceProvinceVal,
            ServicePostalCode: servicePostalCodeVal,
            registerNames: registerNames,
            signingAuthority: signingAuthority,
            Comment: (document.getElementById('formComments') as HTMLInputElement).value,
            differentRegistration: registerAsNewLender ? '1' : '0',
        }
        runInnerFunction('ReactShell.reactSaveLenderContact', newMortgageLender);
        props.setShowLender(false);
        props.callBranch();
    }
    return (
        <Modal scrollable={true} centered show={true} size="xl">
            <Modal.Header>
                <Modal.Title>Lender Information</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleSubmit} autoComplete="off" id="NewLenderForm">
                    <Row>
                        <Col xs="6"><h3>Lender</h3></Col>
                        <Col xs="6"><h3>Branch</h3></Col>
                    </Row>

                    <Row className="mb-4">
                        <Form.Group as={Col} xs="6" controlId="formLenderName">
                            <Form.Label>Lender Name</Form.Label>
                            {props.typeOfLender !== "Misc" ?
                                <Form.Control required defaultValue={props.LenderEntry['Name']} disabled />
                                :
                                <Form.Control required style={{ display: 'inline-block' }}
                                    value={selectLenderName}
                                    className="Form-Lender-Name"
                                    placeholder="Please enter Lender Name..."
                                    onChange={(e) => {
                                        setSelectLenderName(e.target.value);
                                    }} />
                            }
                        </Form.Group>

                        <Form.Group as={Col} xs="6" controlId="formBranchName">
                            <Form.Label>Branch Name</Form.Label>
                            <Form.Control required defaultValue={props.subBranch?.Branch ? props.subBranch.Branch : ''} />
                        </Form.Group>
                    </Row>

                    <Row className="mb-4">
                        {/* This will need some work */}

                        {(!props.LenderEntry['LDDLenderID'] || props.LenderEntry['LDDLenderID'] === 1000001) && (props.LenderEntry['LenderID'] === 1000000001) ?
                            <Form.Group as={Col} xs="2" controlId="formLenderCode">
                                <Form.Label>Lender Code</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                    <i className="fa-regular fa-list-ul" id="button-addon1" onClick={() => {
                                        setSelectLenderCode(true);
                                    }}>
                                    </i>
                                    </InputGroup.Text>
                                    <Form.Control value={selectLenderCodeName} disabled />
                                    <InputGroup.Text className="secondary">
                                    <i className="fa-regular fa-xmark" id="button-delete-lender-code" onClick={() => {
                                        setSelectLenderCodeName('');
                                    }}>
                                    </i>
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                            
                            : 
                            
                            <Form.Group as={Col} xs="2" controlId="formLenderCode">
                                <Form.Label>Lender Code</Form.Label>
                                <Form.Control value={props.LenderEntry['LenderProgramID'] ? props.LenderEntry['LenderProgramID'] : ''} disabled />
                            </Form.Group>
                        }

                        <Form.Group as={Col} xs="2" controlId="formPrivateLender">
                            <Form.Label>Private Lender</Form.Label>
                            <Form.Check required inline label="Yes" name="PrivateLender" type="radio" className="Form-Private-Lender"
                                onChange={() => {
                                    setPrivateLenderBoolean(true);
                                }} />
                            <Form.Check required inline label="No" name="PrivateLender" type="radio"
                                onChange={() => {
                                    setPrivateLenderBoolean(false);
                                }} />
                        </Form.Group>

                        <Form.Group as={Col} xs="2" controlId="formCorporationCheckbox">
                            <Form.Label>Corporation</Form.Label>
                            <Form.Check defaultChecked={true} name="CorporationCheckbox" className="Form-Corporation" />
                        </Form.Group>


                        <Form.Group as={Col} xs="3" controlId="formTransitBranch">
                            <Form.Label>Transit/Branch #</Form.Label>
                            <Form.Control defaultValue={props.subBranch?.TransitNum ? props.subBranch.TransitNum : ''} />
                        </Form.Group>

                        <Form.Group as={Col} xs="3" controlId="formInstitutionBranch">
                            <Form.Label>Institution #</Form.Label>
                            <Form.Control />
                        </Form.Group>
                    </Row>

                    {privateLenderBoolean &&
                        <Row className="mb-4">
                            <Form.Group as={Col} xs="6" controlId="formNotOnTitle">
                                <Form.Label>Not on Title</Form.Label>
                                <Form.Control placeholder="" />
                            </Form.Group>
                        </Row>
                    }

                    <Row>
                        <Col xs="12">
                            <h3>Contact</h3>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Form.Group as={Col} xs="6" controlId="formResponsiblePerson">
                            <Form.Label>Responsible Person</Form.Label>
                            <Form.Control />
                        </Form.Group>
                    </Row>

                    <Row className="mb-4">
                        <Form.Group as={Col} xs="3" controlId="formPhoneNumber">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control />
                        </Form.Group>

                        <Form.Group as={Col} xs="3" controlId="formFaxNumber">
                            <Form.Label>Fax Number</Form.Label>
                            <Form.Control />
                        </Form.Group>

                        <Form.Group as={Col} xs="4" controlId="formEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control />
                        </Form.Group>
                    </Row>

                    {/* Mailing Address */}

                    <Row>
                        <Col xs="6">
                            <h3>Mailing Address</h3>
                        </Col>

                        <Col xs="6">
                            <h3>Service Address</h3>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs="6">
                        </Col>

                        <Col xs="6">

                            <Form.Group as={Col} controlId="formServiceAddressCheckbox">
                                <Form.Check inline label="Same as Mailing Address" name="NewLenderCheckbox"
                                    onChange={e => {
                                        setServiceAddressAsMailAddress(e.currentTarget.checked);
                                    }
                                    } />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col xs="6">
                            <Row className="mb-4">
                                <Form.Group as={Col} xs="12" controlId="formStreet">
                                    <Form.Label>Street</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                            </Row>

                            <Row className="mb-4">
                                <Form.Group as={Col} xs="6" controlId="formCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                                <Form.Group as={Col} xs="6" controlId="formProvince">
                                    <Form.Label>Province</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                            </Row>

                            <Row className="mb-4">
                                <Form.Group as={Col} xs="4" controlId="formPostalCode">
                                    <Form.Label>Postal Code</Form.Label>
                                    <Form.Control />
                                </Form.Group>
                            </Row>
                        </Col>

                        <Col xs="6">
                            {/* Service Address */}
                            {serviceAddressAsMailAddress ?
                                <></>
                                :
                                <>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} xs="12" controlId="formServiceStreet">
                                            <Form.Label>Street</Form.Label>
                                            <Form.Control />
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} xs="6" controlId="formServiceCity">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control />
                                        </Form.Group>

                                        <Form.Group as={Col} xs="6" controlId="formServiceProvince">
                                            <Form.Label>Province</Form.Label>
                                            <Form.Control />
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-4">
                                        <Form.Group as={Col} xs="4" controlId="formServicePostalCode">
                                            <Form.Label>Postal Code</Form.Label>
                                            <Form.Control />
                                        </Form.Group>
                                    </Row>
                                </>
                            }
                        </Col>
                    </Row>

                    {props.LenderEntry['LenderID'] === 1000000001 ?
                        <>
                            <Row>
                                <Col xs="12">
                                    <h3>New Lender</h3>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Form.Group as={Col} xs="6" controlId="formNewLender">
                                    <Form.Label>Register as New Lender</Form.Label>
                                    <Form.Check inline name="NewLenderCheckbox"
                                        onChange={e => {
                                            setRegisterAsNewLender(e.currentTarget.checked);
                                        }
                                        } />
                                </Form.Group>

                                {registerAsNewLender ?
                                    <>
                                        <Col xs="6">
                                            <Form.Label>Register As</Form.Label>
                                            <Form.Group as={Col} controlId="formNewLenderName">
                                                {registerNames.map((element: Register, index: number) => {
                                                    return (
                                                        <Row key={`Row-Register-${index}`}>
                                                            <Col key={`Col-Register-Name-${index}`}>
                                                                <Form.Control placeholder="Name" key={`Register-name-${index}`} value={element.name} onChange={
                                                                    (e) => {
                                                                        let registers = [...registerNames];
                                                                        let shallowcopy = { ...registers[index] };
                                                                        shallowcopy.name = e.currentTarget.value;
                                                                        registers[index] = shallowcopy;
                                                                        // remove all empty names
                                                                        registers = registers.filter((auth) => auth.name !== '');
                                                                        // add empty end obj
                                                                        if (registers[registers.length - 1]?.name !== '') {
                                                                            let newEntry: Register = {
                                                                                name: '',
                                                                            }
                                                                            registers[registers.length] = newEntry;
                                                                        }
                                                                        setRegisterNames(registers);
                                                                    }
                                                                }>
                                                                </Form.Control>
                                                            </Col>
                                                        </Row>
                                                    )
                                                })}
                                            </Form.Group>
                                        </Col>
                                    </>
                                    : <></>
                                }
                            </Row> </> : null}

                    <Row>
                        <Col xs="12">
                            <h3>Signing Authority</h3>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Form.Group as={Col} controlId="formSigningAuthority">
                            {signingAuthority.map((element: SigningAuthority, index: number) => {
                                return (
                                    <Row key={`Row-SigningAuthority=${index}`}>
                                        <Col xs="6" key={`Col-Name-SigningAuthority=${index}`}>
                                            <Form.Control placeholder="Name" key={`SigningAuthority-name-${index}`} value={element.name} onChange={
                                                (e) => {
                                                    let auths = [...signingAuthority];
                                                    let shallowcopy = { ...auths[index] };
                                                    shallowcopy.name = e.currentTarget.value;
                                                    auths[index] = shallowcopy;
                                                    // remove all empty names
                                                    auths = auths.filter((auth) => auth.name !== '');
                                                    // add empty end obj
                                                    if (auths[auths.length - 1]?.name !== '') {
                                                        let newEntry: SigningAuthority = {
                                                            name: '',
                                                            title: '',
                                                        }
                                                        auths[auths.length] = newEntry;
                                                    }
                                                    setSigningAuthority(auths);
                                                }
                                            } />
                                        </Col>
                                        <Col xs="3" key={`Col-Title-SigningAuthority=${index}`}>
                                            <Form.Control placeholder="Title" key={`SigningAuthority-Title-${index}`} value={element.title} onChange={
                                                (e) => {
                                                    let auths = [...signingAuthority];
                                                    let shallowcopy = { ...auths[index] };
                                                    shallowcopy.title = e.currentTarget.value;
                                                    auths[index] = shallowcopy;
                                                    setSigningAuthority(auths);
                                                }
                                            } />
                                        </Col>
                                    </Row>
                                )
                            })}
                        </Form.Group>
                    </Row>

                    <Row>
                        <Col xs="12">
                            <h3>Comments</h3>
                        </Col>
                    </Row>

                    <Row>
                        <Form.Group as={Col} xs="12" controlId="formComments">
                            <Form.Control as="textarea" rows={5} />
                        </Form.Group>
                    </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer style={{ zIndex: 1 }}>
                <Button variant="outline-primary" onClick={async () => {
                    props.setShowLender(false);
                    props.callBranch();
                }}>Cancel</Button>
                <Button variant="primary" type="submit" form="NewLenderForm"
                >Save</Button>
            </Modal.Footer>
            {selectLenderCode &&
                <SelectLenderFieldList
                    closeFunc={setSelectLenderCode}
                    listName={"MortgageLenderSelectFieldList"}
                    setLenderField={setSelectLenderCodeName}
                    fieldType={'Code'}
                />
            }
        </Modal>
    )
}